import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";

export default function LocationSection() {
    const { t, i18n } = useTranslation();
    const [locations, setLocations] = useState([]);
    UseScrollAnimation();

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/locations")
            .then((response) => response.json())
            .then((data) => setLocations(data))
            .catch((error) => console.error("Error fetching locations:", error));
    }, []);

    const isArabic = i18n.language === "ar";

    return (
        <section className="py-[40px]">
            <div className="container f-col flex justify-center gap-[20px] flex-wrap">
                {locations.map((location) => (
                    <div
                        key={location.id}
                        className="w-100 w-[31%] rounded-[4px] shadow-[0px_0px_10px_#00000030]"
                    >
                        <div className="w-full h-[250px]">
                            <img
                                className="w-full h-full rounded-t-[4px]"
                                src={`https://ligasos-laravel.ligasos.co/storage/app/public/${location.image_path}`}
                                alt={`location-${location.id}`}
                            />
                        </div>
                        <div className="p-[15px] flex flex-col justify-between gap-[10px]">
                            <div className="font-bold text-[#0b2c3d] text-[20px]">
                                {t(`Location : ${isArabic ? location.location_ar : location.location_en}`)}
                            </div>
                            <div className="flex flex-col gap-[12px]">
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("Phone Number")} : </span>
                                    <Link className="dir-ltr" to={`tel:${location.phone_number}`}>
                                        {location.phone_number}
                                    </Link>
                                </div>
                                <div className="flex items-center gap-[5px]">
                                    <span className="font-bold capitalize">{t("By Email")} : </span>
                                    <Link to={`mailto:${location.email}`}>{location.email}</Link>
                                </div>
                                <div className="flex flex-col gap-[5px]">
                                    <span className="font-bold capitalize">{t("working hours")}</span>
                                    <Link
                                        to={location.download_link}
                                        className="flex flex-col"
                                        target="_blank"
                                    >
                                        {(isArabic ? location.working_hours_ar : location.working_hours_en)
                                            .split(isArabic ? "الجمعة" : "Friday")
                                            .map((part, index) => (
                                                <span key={index}>
                                                    {t(index === 0 ? part.trim() : `${isArabic ? "الجمعة" : "Friday"} ${part.trim()}`)}
                                                </span>
                                            ))}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}